import { CriterionSelected } from "./validation-criterion";
import { DynamicFiledSelected } from "./dynamic-field";

export type VehicleValidation = {
  id: string;
  checklist_id: string;
  unitCode: string;
  umaCode: string;
  plate: string;
  criteria: { [key: string]: CriterionSelected };
  fields: { [key: string]: DynamicFiledSelected };
  parameters?: { [key: string]: any };
  observations: string;
  evidences?: string[];
  status?: VehicleValidationStatus | string;
  modified?: boolean;
}

export enum VehicleValidationStatus {
  inReview = 'inReview',
  observation = 'observation',
  completed = 'completed',
  incompleted = 'incompleted',
  send = 'send',
}

export interface VehicleConvoy {
  id: number;
  name: string;
}

export interface VehicleGroup {
  id: number;
  name: string;
  convoys?: VehicleConvoy[];
}

export interface VehicleOperation {
  id: number;
  name: string;
  groups?: VehicleGroup[];
}

export interface SelectableVehicle {
  id: number;
  plate: string;
  unitCode: string;
  operations: number[];
  groups: number[];
  convoys: number[];
  gps? : string;
  cipia? : string;
}


export type EvidenceFile = {
  file: File;
  preview: any;
  progress: number;
  uploaded: boolean;
  sizeLabel: string;
};


export type EquipmentStatus = {
  plate: string;
  alcohol?: Date;
  adas?: Date;
  alcoholEventName?: string;
  adasEventName?: string;
}
